import { render, staticRenderFns } from "./ToolboxTalkSendModal.vue?vue&type=template&id=63a5ea12&"
import script from "./ToolboxTalkSendModal.vue?vue&type=script&lang=js&"
export * from "./ToolboxTalkSendModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports